@if (toasts(); as toasts) {
  <div class="toast-container" [@toastStack]="toasts.length">
    @for (toast of toasts; track toast.id) {
      <div class="toast" [ngClass]="[toast.type, toast.removing ? 'removing' : '']">
        <!-- ICON -->
        <div class="icon">
          <img [src]="toast.type | toastIcon" [alt]="toast.type + '_Icon'" />
        </div>
        <!-- CONTENT -->
        <div class="content">
          <div class="title">
            {{ toast.title | titlecase }}
          </div>
          <div class="message">
            {{ toast.message }}
          </div>
        </div>
      </div>
    }
  </div>
}
